/*
  Hides the Seal Subscriptions widget while a product is being sold as a
  pre-order, so a pre-order can only ever be a one-time purchase.

  Why this is not purely CSS:

  Seal and the pre-order share the same product form — Seal contributes the
  `selling_plan` value that turns an add-to-cart into a subscription. The
  subscription option can be pre-selected (see the `.sls-option-container:
  nth-of-type(2).sls-active` rules in seal-freq-buttons.liquid), so hiding the
  widget on its own risks the worst outcome available: an invisible, still
  selected plan that quietly signs the customer up for a recurring charge on a
  product that has not been made yet. The plan inputs are therefore disabled as
  well — disabled inputs are not submitted.

  Seal renders asynchronously and the theme re-renders the buy button on every
  variant change, so this re-runs on mutations rather than once on load.
*/
(function () {
  var SCOPE_SELECTOR = '.product, .featured-product';
  var HIDE_CLASS = 'preorder-hide-subscriptions';
  var WIDGET_SELECTOR = '.sealsubs-target-element, .sealsubs-container';
  var MARKER = 'preorderDisabled';

  function gateIsOpen() {
    return document.documentElement.classList.contains('preorder-live');
  }

  function reset() {
    // Undo everything first, so a variant switching back into stock gets its
    // subscription option back instead of being left silently un-subscribable.
    document.querySelectorAll('.' + HIDE_CLASS).forEach(function (scope) {
      scope.classList.remove(HIDE_CLASS);
    });
    document.querySelectorAll('[data-preorder-disabled]').forEach(function (input) {
      input.disabled = false;
      delete input.dataset[MARKER];
    });
  }

  function apply() {
    reset();
    if (!gateIsOpen()) return;

    document.querySelectorAll('button[data-preorder="true"]').forEach(function (button) {
      var scope = button.closest(SCOPE_SELECTOR);
      if (!scope || !scope.querySelector(WIDGET_SELECTOR)) return;

      scope.classList.add(HIDE_CLASS);

      // Belt and braces: the widget is hidden, and any plan it may already have
      // selected is stopped from reaching the cart. Only inputs disabled here
      // are marked, so reset() never re-enables one the app disabled itself.
      //
      // Scoped to the product wrapper rather than the <form>: Seal injects its
      // widget as a sibling of the form, so a form-scoped lookup finds nothing
      // and the guard silently does nothing. The form is inside the wrapper, so
      // this covers plan inputs in either position.
      scope.querySelectorAll('[name="selling_plan"]').forEach(function (input) {
        if (input.disabled) return;
        input.disabled = true;
        input.dataset[MARKER] = 'true';
      });
    });
  }

  function start() {
    apply();
    // Deliberately NOT watching `class`: apply() edits class itself, which would
    // make the observer retrigger itself forever.
    new MutationObserver(apply).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-preorder'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
